import type { DBFreelancer, DBFreelancerContact, FreelancerContactRole } from "@/lib/db-types";

/**
 * VIB-2934: ren logikk for kontaktpersoner og hurtigknappene på profilen.
 * Ingen Supabase her.
 */

export const CONTACT_ROLES: { value: FreelancerContactRole; label: string }[] = [
  { value: "agent", label: "Agent" },
  { value: "producer", label: "Produsent" },
  { value: "contact", label: "Kontakt" },
  { value: "billing", label: "Fakturering" },
  { value: "other", label: "Annet" },
];

export function contactRoleLabel(c: Pick<DBFreelancerContact, "role" | "role_note">): string {
  if (c.role === "other" && c.role_note?.trim()) return c.role_note.trim();
  return CONTACT_ROLES.find((r) => r.value === c.role)?.label ?? "Kontakt";
}

export interface QuickContact {
  /** Fornavn når nummeret er en kontaktpersons, ellers null. */
  callName: string | null;
  phone: string | null;
  emailName: string | null;
  email: string | null;
}

const firstName = (name: string) => name.trim().split(/\s+/)[0] ?? name;

/**
 * Hvem «Ring» og «E-post» går til: frilanserens egne felt først, ellers første
 * kontaktperson (sortert) som har feltet. Firma og frilansere via agent har ofte
 * bare kontaktpersonens nummer.
 */
export function quickContact(
  f: Pick<DBFreelancer, "phone" | "email">,
  contacts: readonly Pick<DBFreelancerContact, "name" | "role" | "phone" | "email" | "sort_order">[],
): QuickContact {
  const sorted = [...contacts].sort((a, b) => a.sort_order - b.sort_order);
  const phoneContact = f.phone ? null : sorted.find((c) => c.phone);
  const emailContact = f.email ? null : sorted.find((c) => c.email);
  const label = (c: (typeof sorted)[number] | undefined | null) =>
    c ? (c.role === "agent" ? "agent" : firstName(c.name)) : null;
  return {
    callName: label(phoneContact),
    phone: f.phone ?? phoneContact?.phone ?? null,
    emailName: label(emailContact),
    email: f.email ?? emailContact?.email ?? null,
  };
}
